import { render, staticRenderFns } from "./ProductSerialsDocument.vue?vue&type=template&id=5b97084e"
import script from "./ProductSerialsDocument.vue?vue&type=script&lang=js"
export * from "./ProductSerialsDocument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports